import { BROWSER_NAME } from "../../utils/detection";

export const API_DEFAULTS = {
    BROWSER: process.env.REACT_APP_BROWSER || BROWSER_NAME,
    CLIENT_IP: process.env.REACT_APP_CLIENT_IP || "127.0.0.1", // Fallback, updated dynamically
    CONSENT_HANDLE: process.env.REACT_APP_CONSENT_HANDLE || "",
    FIUID: process.env.REACT_APP_FIUID || "",
};

/**
 * Updates the dynamic client IP in the API defaults.
 * Should be called during app initialization.
 */
export const setDynamicClientIP = (ip: string) => {
    API_DEFAULTS.CLIENT_IP = ip;
};

export const DEFAULT_DEVICE_ID_PREFIX = "web-";
